import { render } from "./KitchenDisplayTypeTable.vue?vue&type=template&id=6c268a09"
import script from "./KitchenDisplayTypeTable.vue?vue&type=script&lang=js"
export * from "./KitchenDisplayTypeTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__